module.exports = __webpack_public_path__ + "img/Group 5356.31667aee.png";